/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

module.exports = require('./lib/extend');




//////////////////
// WEBPACK FOOTER
// ./~/node.extend/index.js
// module id = 418
// module chunks = 49